import { ReactNode, forwardRef } from 'react';
import { CreateReplyProps } from './NewReply';
import { EditorRef } from '../rich-text-editor/Editor';
import StructuredTextCard from './StructuredTextCard';

export type RepliesListProps = {
    /**
     * Reply value
     */
    reply: { rawContent: string; structuredContent: string };
    /**
     * Children which is the individual reply component
     */
    children: ReactNode[];
    /**
     * Whether new reply can be created
     */
    canCreate: boolean;
    /**
     * Whether reply editor is currently focused
     */
    isEditorFocused: boolean;
    /**
     * Whether create reply query is loading
     */
    isCreating: boolean;
    /**
     * Additonal actions to show in button dropdown
     */
    extraActions?: { label: string; onClick: (params: CreateReplyProps) => void }[];
    /**
     * Callback when new reply content changes
     */
    onNewReply: (reply: { rawContent: string; structuredContent: string }) => void;
    /**
     * Callback when new reply is being created
     */
    onCreate: (params: CreateReplyProps) => void;
    /**
     * Callback when new reply editor focused state changes
     */
    onEditorFocused: (isFocused: boolean) => void;
};

const RepliesList = forwardRef(function RepliesList(
    { reply, children, canCreate, isEditorFocused, isCreating, extraActions, onNewReply, onCreate, onEditorFocused }: RepliesListProps,
    ref: React.ForwardedRef<EditorRef>
): JSX.Element {
    return (
        <div className="border-t pt-4">
            <ul className="flex flex-col gap-4 pb-2">{children}</ul>
            {canCreate && (
                <StructuredTextCard.NewReply
                    ref={ref}
                    reply={reply}
                    replyEditorFocused={isEditorFocused}
                    isCreating={isCreating}
                    extraActions={extraActions}
                    onCreate={onCreate}
                    onNewReply={onNewReply}
                    onReplyEditorFocused={onEditorFocused}
                />
            )}
        </div>
    );
});

export default RepliesList;
